import axios from '@/axios'

class OrderInvoiceDataService {
  getAllOrderInvoices(page: number): Promise<any> {
    return axios.get(`/orderInvoices/getAllOrderInvoices?page=${page}`)
  }
  async getAllOrderInvoicesForOrder(order_id: any): Promise<any> {
    return axios.get(`/orderInvoices/${order_id}/getAll`)
  }
  getOrderInvoiceById(id: any): Promise<any> {
    return axios.get(`/orderInvoices/${id}/get`)
  }
  getOrderInvoiceForOrderByType(id: any, type: any): Promise<any> {
    return axios.get(`/orderInvoices/${id}/${type}/get`)
  }
  generateInvoiceById(id: any): Promise<any> {
    return axios.get(`/orderInvoices/${id}/generate`)
  }
  add(data: any): Promise<any> {
    return axios.post('/orderInvoices/add', data)
  }
  update(id: any, data: any): Promise<any> {
    return axios.put(`/orderInvoices/${id}/update`, data)
  }
  delete(id: any): Promise<any> {
    return axios.delete(`/orderInvoices/${id}/delete`)
  }
}
export default new OrderInvoiceDataService()
